import React, { ReactElement } from 'react'

import styles from './BCRow.module.less'

type RowProps = {
  height?: number
  width?: number | string
  children?: ReactElement | ReactElement[] | string
  centerContent?: boolean
  padded?: boolean
  className?: string
}

export default function Row({
  height = 35,
  width = '100%',
  centerContent = false,
  padded = false,
  className = '',
  children,
}: RowProps): ReactElement {
  const customClassName = centerContent ? styles.Row_Center : ``
  const paddedClassName = padded ? styles.Row_Padded : ``
  const classes = `${styles.Row} ${customClassName} ${paddedClassName} ${className}`

  return (
    <div
      className={classes}
      style={{
        height: height,
        maxHeight: height,
        width: width,
      }}
    >
      {children}
    </div>
  )
}
